"use client";

import { Amplify } from 'aws-amplify';
import { ReactNode, useEffect } from 'react';

// Import amplify_outputs.json at build time
// @ts-ignore - amplify_outputs.json is generated at runtime and gitignored
import amplifyOutputs from '../../amplify_outputs.json';

// Configure Amplify for User Pool authentication only
// Remove identity_pool_id to prevent AWS credential fetching (not needed for login)
const config = {
  ...amplifyOutputs,
  auth: {
    ...amplifyOutputs.auth,
    identity_pool_id: undefined, // Disable Identity Pool - only use User Pool for authentication
  }
};

Amplify.configure(config, { ssr: true });

interface AmplifyProviderProps {
  children: ReactNode;
}

export function AmplifyProvider({ children }: AmplifyProviderProps) {
  useEffect(() => {
    // Log configuration in development
    if (process.env.NODE_ENV === 'development') {
      console.log('Amplify configured with:', {
        userPoolId: amplifyOutputs.auth?.user_pool_id,
        region: amplifyOutputs.auth?.aws_region,
        hasClientId: !!amplifyOutputs.auth?.user_pool_client_id,
        hasIdentityPool: false, // Disabled for login-only mode
      });
    }
  }, []);

  return <>{children}</>;
}
